import { RoundPoint, RoundPointsFieldEnum } from "@/types/types";

export function getRoundPointFieldValue(roundPoint: RoundPoint, field: RoundPointsFieldEnum): number {
	switch (field) {
		case RoundPointsFieldEnum.teamFastestTimeSeconds:
			return roundPoint.team_fastest_time_seconds ?? 0;
		case RoundPointsFieldEnum.teamSmallestDifferenceValue:
			return roundPoint.team_smallest_difference_value ?? 0;
		case RoundPointsFieldEnum.points:
		default:
			return roundPoint.points ?? 0;
	}
}

export function setRoundPointFieldValue(roundPoint: RoundPoint, field: RoundPointsFieldEnum, value: number): RoundPoint {
	switch (field) {
		case RoundPointsFieldEnum.teamFastestTimeSeconds:
			return { ...roundPoint, team_fastest_time_seconds: value };
		case RoundPointsFieldEnum.teamSmallestDifferenceValue:
			return { ...roundPoint, team_smallest_difference_value: value };
		case RoundPointsFieldEnum.points:
		default:
			return { ...roundPoint, points: value };
	}
}
